function setCssVariable(varName) {
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty(varName, `${vh}px`)
}

export default setCssVariable
